import { FC, FunctionComponent } from "react";

interface InternalFormRowProps extends FormRowProps {
    type: "divider" | "none" | "horizontal" | "with-columns"
}

interface FormRowProps {

}

const InternalFormRow: FunctionComponent<React.PropsWithChildren<InternalFormRowProps>> = (props) => {
    let { children, type} = props;

    let className = "form-row";

    switch(type){
        case "divider" : className += " divider"; break;
        case "horizontal" : className += " horizontal"; break;
        case "with-columns" : className += " with-columns"; break;
    }

    return ( 
        <div className={className}>
           {children}
        </div>
    );
}

interface FormInputProps {
    id: string,
    title: string,
    isError: boolean,
    errorMessage: string,
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void, // delete this
    onChangeValue?: (value: string) => void,
    value?: string,
    type? : React.HTMLInputTypeAttribute,
    disabled? : boolean,
    min?: string
    placeholderTxt?: string
}
 
export const FormInput: FunctionComponent<FormInputProps> = (props) => {
    let {id , title, isError: isInputError, errorMessage, value, onChange, onChangeValue, type, disabled, min, placeholderTxt} = props;
    
    return ( 
        <>
            <label htmlFor={id}>{title}</label>
            <div className="">
                <input 
                    disabled={disabled}
                    id={id}
                    className={`form-control ${isInputError ? "error" : ""}`} 
                    type={type ?? "text"} 
                    value={value ?? ''}
                    min={min}
                    placeholder={placeholderTxt}
                    onChange={e => {onChange && onChange(e); onChangeValue && onChangeValue(e.target.value)}} 
                />
                {isInputError && <span className="error">{errorMessage}</span>}
            </div>
        </>
    );
}

interface FormInputColorpickerProps {
    id: string,
    title: string,
    isError: boolean,
    errorMessage: string,
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void, // delete this
    onChangeValue?: (value: string) => void,
    value?: string,
    type? : React.HTMLInputTypeAttribute,
    disabled? : boolean
}
 
export const FormInputColorpicker: FunctionComponent<FormInputColorpickerProps> = (props) => {
    let {id , title, isError: isInputError, errorMessage, value, onChange, onChangeValue, type, disabled} = props;
    
    return ( 
        <>
            <label htmlFor={id}>{title}</label>
            <div className="">
                <input 
                    disabled={disabled}
                    id={id}
                    className={`form-control ${isInputError ? "error" : ""}`} 
                    type={`color`} 
                    value={value}
                    onChange={e => {onChange && onChange(e); onChangeValue && onChangeValue(e.target.value)}} 
                />
                {isInputError && <span className="error">{errorMessage}</span>}
            </div>
        </>
    );
}

interface FormInputTextareaProps {
    id: string,
    title: string,
    isError: boolean,
    errorMessage: string,
    onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void, // delete this
    onChangeValue?: (value: string) => void,
    value?: string
}
 
export const FormInputTextarea: FunctionComponent<FormInputTextareaProps> = (props) => {
    let {id , title, isError: isInputError, errorMessage, value, onChange, onChangeValue} = props;
    
    return ( 
        <>
            <label htmlFor={id}>{title}</label>
            <div className="">
                <textarea 
                    rows={10}
                    id={id}
                    className={`form-control ${isInputError ? "error" : ""}`} 
                    value={value}
                    onChange={e => {onChange(e); onChangeValue && onChangeValue(e.target.value)}} 
                />
                {isInputError && <span className="error">{errorMessage}</span>}
            </div>
        </>
    );
}

interface FormInputNumberProps {
    id: string,
    title: string,
    min?: number,
    max?: number,
    step?: number,
    isError: boolean,
    errorMessage: string,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void, // delete this
    onChangeValue?: (value: string) => void,
    onBlurFires?: (value: string) => void,
    value?: string | number
}
 
export const FormInputNumber: FunctionComponent<FormInputNumberProps> = (props) => {
    let {id , title, min, max, step, isError: isInputError, errorMessage, value, onChange, onChangeValue, onBlurFires} = props;
    
    return ( 
        <>
            <label htmlFor={id}>{title}</label>
            <div className="">
                <input 
                    id={id}
                    className={`form-control ${isInputError ? "error" : ""}`} 
                    type="number"
                    min={min}
                    max={max}
                    step={step} 
                    value={value}
                    onChange={e => {onChange(e); onChangeValue && onChangeValue(e.target.value)}} 
                    onBlur={(e) => {onBlurFires && onBlurFires(e.target.value)}}
                />
                {isInputError && <span className="error">{errorMessage}</span>}
            </div>
        </>
    );
}


export interface FormSelectProps {
    id: string,
    title: string,
    selectedValue: string | undefined,
    isError: boolean,
    errorMessage: string,
    onChange: (value:string) => void,
    defaultValueText?: string,
    options: {value:string, name:string}[],
    hideDefaultValue? : boolean,
}

export type SelectOption = {
    value: string,
    name: string
}

export const FormSelect:FunctionComponent<FormSelectProps> = (props) =>{
    let {id , title, selectedValue, isError, errorMessage, onChange, options, defaultValueText, hideDefaultValue = false} = props;

    const internalOnChange = (event:React.ChangeEvent<HTMLSelectElement>) =>{
        onChange(event.target.value);
    }

    return <>
        <label htmlFor={id}>{title}</label>
        <div className="select">
            <select 
                className="form-control" 
                name="" 
                id={id} 
                onChange={internalOnChange}
                value={selectedValue}
            >
                {hideDefaultValue ? null : <option value="">{defaultValueText ?? "Select"}</option>}
                {options.map( (it, index) => {
                    return <option key={`${it.value}-${index}`} value={it.value}>{it.name}</option>
                })}
            </select>
        </div>
        {isError && <span className="error">{errorMessage}</span>}
    </>
}

export const FormRowDivider = (props: FormRowProps) => InternalFormRow({type:'divider', ...props})
export const FormRowHorizontal = (props: FormRowProps) => InternalFormRow({type:'horizontal', ...props})
export const FormRow = (props: FormRowProps) => InternalFormRow({type:'none', ...props})
export const FormRowWithColumns = (props: FormRowProps) => InternalFormRow({type:'with-columns', ...props})